import { createStore } from "vuex";
import proctoring from "./useProctoringStore";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  modules: {
    proctoring,
  },

  state: {
    access: null,
    refresh: null,
    user: null,
    roles: [],
    isAuthenticated: false,
    accessToken: null,
    refreshToken: null,
    tokenExp: null,
    josh_id: null,
    loginError: null,
  },

  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    user: (state) => state.user,
    access: (state) => state.access,
    refresh: (state) => state.refresh,
    roles: (state) => state.roles,
    getAccessToken: (state) => state.accessToken,
    getRefreshToken: (state) => state.refreshToken,
    getTokenExp: (state) => state.tokenExp,
    josh_id: (state) => state.josh_id,
    login_error: (state) => state.loginError,
  },

  mutations: {
    setLoggedInInfo(state, payload) {
      const userData = payload.data;

      state.isAuthenticated = true;

      state.access = userData.access;
      state.refresh = userData.refresh;

      state.user = {
        id: userData.user_id,
        full_name: userData.full_name,
        email: userData.email,
        phone: userData.phone,
      };

      state.roles = userData.roles || [];
    },

    setLogout(state) {
      state.access = null;
      state.refresh = null;
      state.user = null;
      state.roles = [];
      state.isAuthenticated = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.josh_id = null;
      state.loginError = null;

      localStorage.removeItem("exam_id");
      localStorage.removeItem("exam_name");
      localStorage.removeItem("room_id");
      localStorage.removeItem("room_name");
      localStorage.removeItem("exam_attempt_id");
    },
    setAccessToken(state, token) {
      state.accessToken = token;
    },
    setRefreshToken(state, token) {
      state.refreshToken = token;
    },
    setExpDate(state, date) {
      state.tokenExp = date;
    },
    setJoshInfo(state, data) {
      state.josh_id = data;
    },
    setLoginError(state, data) {
      state.loginError = data;
    },
  },

  actions: {
    async loginWithPassword({ commit, dispatch }, data) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_ROOT}/auth/login/`,
          data
        );

        commit("setLoggedInInfo", response.data);
        commit("setAccessToken", response.data.data.access);
        commit("setRefreshToken", response.data.data.refresh);
        if (response.data.data.josh_id != null) {
          commit("setJoshInfo", response.data.data.josh_id);
        }

        dispatch("saveToken");

        return response.data;
      } catch (error) {
        const message =
          error.response?.data?.message ||
          error.response?.data?.error?.detail ||
          "Login failed";

        commit("setLoginError", message);

        return {
          status: error.response?.status,
          message,
        };
      }
    },
    async sendStudentOtp(_, { email }) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_ROOT}/auth/login/send-otp/`,
          { email }
        );
        return response.data;
      } catch (error) {
        console.error("Send OTP Error:", error);
        return error.response?.data ?? null;
      }
    },

    async loginWithOtp({ commit, dispatch }, { email, otp }) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_ROOT}/auth/login/verify-otp/`,
          { email, otp }
        );
        commit("setLoggedInInfo", response.data);
        commit("setAccessToken", response.data.data.access);
        commit("setRefreshToken", response.data.data.refresh);
        if (response.data.data.josh_id != null) {
          commit("setJoshInfo", response.data.data.josh_id);
        }
        dispatch("saveToken");
        return response.data;
      } catch (error) {
        console.error("OTP Login Error:", error);
        return error.response?.data ?? null;
      }
    },

    logout({ commit }) {
      commit("setLogout");
      commit("setExpDate", null);
    },
    saveToken({ state, commit }) {
      const token = state.accessToken;
      if (!token) return;

      try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        );
        const decoded = JSON.parse(jsonPayload);

        const expDate = new Date(decoded.exp * 1000);
        commit("setExpDate", expDate);
      } catch (err) {
        console.error("Failed to decode JWT:", err);
      }
    },
  },

  plugins: [
    createPersistedState({
      key: "exam-app",
      storage: window.localStorage,
      paths: [
        "access",
        "refresh",
        "user",
        "roles",
        "isAuthenticated",
        "accessToken",
        "refreshToken",
        "tokenExp",
      ],
    }),
  ],
});
